var _mask, _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcVideoDesc = function SvgIcVideoDesc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2088_59703",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 2,
    stroke: "white",
    strokeWidth: 5.5,
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_2088_59703)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 7.75L33 3L33 22L28 17.25",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5234 9.54688V18H11.8828V9.54688H14.5234ZM11.7266 7.36719C11.7266 6.99219 11.862 6.6849 12.1328 6.44531C12.4036 6.20573 12.7552 6.08594 13.1875 6.08594C13.6198 6.08594 13.9714 6.20573 14.2422 6.44531C14.513 6.6849 14.6484 6.99219 14.6484 7.36719C14.6484 7.74219 14.513 8.04948 14.2422 8.28906C13.9714 8.52865 13.6198 8.64844 13.1875 8.64844C12.7552 8.64844 12.4036 8.52865 12.1328 8.28906C11.862 8.04948 11.7266 7.74219 11.7266 7.36719Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcVideoDesc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_video_desc.ae3f035b.svg";
export { ForwardRef as ReactComponent };